import React, {useEffect, useState} from "react";
import axios from "axios";
import {baseUrl} from "../Univ";
function WorkerDashboard() {
    const userId = localStorage.getItem("user_id");
    const [worker, setWorker] = useState(null);
    const [workerId, setWorkerId] = useState(null);
    const [assignments, setAssignments] = useState([]);
    const [payments, setPayments] = useState([]);
    const [disputes, setDisputes] = useState([]);
    const [loading, setLoading] = useState(false);
    // ---------------- WORKER PROFILE ----------------
    useEffect(() => {
        if (!userId) return;
        axios.get(
            baseUrl + "worker-profile/" + userId + "/"
        )
            .then((res) => {
                if (res.data.length > 0) {
                    setWorker(res.data[0]);
                    setWorkerId(res.data[0].id);
                }
            })
            .catch(console.log);
    }, [userId]);
    // ---------------- LOAD DASHBOARD ----------------
    useEffect(() => {
        if (!workerId) return;
        loadDashboard();
    }, [workerId]);
    const loadDashboard = async () => {
        try {
            setLoading(true);
            // ---------------- ASSIGNMENTS ----------------
            const assRes = await axios.get(
                baseUrl +
                "assignment-worker/" +
                workerId +
                "/"
            );
            const assignmentData = assRes.data;
            setAssignments(assignmentData);
            // ---------------- PAYMENTS ----------------
            let allPayments = [];
            for (const ass of assignmentData) {
                try {
                    const payRes = await axios.get(
                        baseUrl +
                        "payment-assignment/" +
                        ass.id +
                        "/"
                    );
                    allPayments = [
                        ...allPayments,
                        ...payRes.data
                    ];
                } catch (err) {
                    console.log(err);
                }
            }
            setPayments(allPayments);
            // ---------------- DISPUTES ----------------
            let allDisputes = [];
            for (const ass of assignmentData) {
                try {
                    const disRes = await axios.get(
                        baseUrl +
                        "dispute-assignment/" +
                        ass.id +
                        "/"
                    );
                    allDisputes = [
                        ...allDisputes,
                        ...disRes.data
                    ];
                } catch (err) {
                    console.log(err);
                }
            }
            setDisputes(allDisputes);
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    };
    // ---------------- CALCULATIONS ----------------
    const activeAssignments =
        assignments.filter(
            a => a.status === "ACTIVE"
        ).length;
    const completedAssignments =
        assignments.filter(
            a => a.status === "COMPLETED"
        ).length;
    const totalPresentDays =
        assignments.reduce(
            (sum, item) =>
                sum +
                Number(item.total_present_days || 0),
            0
        );
    const totalEarnings =
        assignments.reduce(
            (sum, item) =>
                sum +
                Number(item.total_amount || 0),
            0
        );
    const totalPayments =
        payments.reduce(
            (sum, item) =>
                sum +
                Number(item.amount || 0),
            0
        );
    const pendingPayments =
        payments.filter(
            p => !p.worker_confirmed
        ).length;
    const openDisputes =
        disputes.filter(
            d => d.status === "OPEN"
        ).length;
    const resolvedDisputes =
        disputes.filter(
            d => d.status === "RESOLVED"
        ).length;
    return (
        <section className="container mt-4">

            <h2 className="mb-4">
                Worker Dashboard
            </h2>

            {worker && (
                <div className="card shadow mb-4">

                    <div className="card-body">

                        <h4>{worker.name}</h4>

                        <p>
                            Mobile : {worker.mobile}
                        </p>

                        <p>
                            Work Type : {worker.work_type}
                        </p>

                        <p>
                            Cost : ₹{worker.cost} / {worker.unit}
                        </p>

                    </div>

                </div>
            )}

            {loading && (
                <div className="alert alert-info">
                    Loading Dashboard...
                </div>
            )}

            {/* FIRST ROW */}

            <div className="row">

                <div className="col-md-3 mb-3">
                    <div className="card bg-primary text-white shadow">
                        <div className="card-body text-center">
                            <h5>Total Tasks</h5>
                            <h2>{assignments.length}</h2>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 mb-3">
                    <div className="card bg-success text-white shadow">
                        <div className="card-body text-center">
                            <h5>Active Tasks</h5>
                            <h2>{activeAssignments}</h2>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 mb-3">
                    <div className="card bg-secondary text-white shadow">
                        <div className="card-body text-center">
                            <h5>Completed Tasks</h5>
                            <h2>{completedAssignments}</h2>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 mb-3">
                    <div className="card bg-warning text-dark shadow">
                        <div className="card-body text-center">
                            <h5>Attendance Days</h5>
                            <h2>{totalPresentDays}</h2>
                        </div>
                    </div>
                </div>

            </div>

            {/* SECOND ROW */}

            <div className="row">

                <div className="col-md-3 mb-3">
                    <div className="card bg-info text-white shadow">
                        <div className="card-body text-center">
                            <h5>Total Earnings</h5>
                            <h2>₹{totalEarnings}</h2>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 mb-3">
                    <div className="card bg-success text-white shadow">
                        <div className="card-body text-center">
                            <h5>Payments Received</h5>
                            <h2>₹{totalPayments}</h2>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 mb-3">
                    <div className="card bg-danger text-white shadow">
                        <div className="card-body text-center">
                            <h5>Pending Payments</h5>
                            <h2>{pendingPayments}</h2>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 mb-3">
                    <div className="card bg-dark text-white shadow">
                        <div className="card-body text-center">
                            <h5>Open Disputes</h5>
                            <h2>{openDisputes}</h2>
                        </div>
                    </div>
                </div>

            </div>

            {/* THIRD ROW */}

            <div className="row">

                <div className="col-md-12 mb-3">
                    <div className="card shadow">
                        <div className="card-body text-center">

                            <h4>
                                Resolved Disputes
                            </h4>

                            <h1>
                                {resolvedDisputes}
                            </h1>

                        </div>
                    </div>
                </div>

            </div>

            {/* RECENT TASKS */}

            <div className="card shadow mt-4">

                <div className="card-header">
                    Recent Tasks
                </div>

                <div className="card-body">

                    <div className="table-responsive">

                        <table className="erp-table-modern">

                            <thead>

                            <tr style={{
                                backgroundColor: "#1bc5ce",
                                color: "white"
                            }}>
                                <th>ID</th>
                                <th>Status</th>
                                <th>Present Days</th>
                                <th>Earnings</th>
                            </tr>

                            </thead>

                            <tbody>

                            {assignments
                                .slice(0, 5)
                                .map((item) => (
                                    <tr key={item.id}>

                                        <td>{item.id}</td>

                                        <td>
                                            {item.status}
                                        </td>

                                        <td>
                                            {item.total_present_days}
                                        </td>

                                        <td>
                                            ₹{item.total_amount}
                                        </td>

                                    </tr>
                                ))}

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

        </section>
    );
}
export default WorkerDashboard;